import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";
import { getStoredToken, refreshSession } from "./api";

function connectToSocket() {
    const backendUrl = getBackendUrl();

    const socket = openSocket(backendUrl, {
      // "flashsocket" e obsoleto e gera fallback desnecessario.
      transports: ["polling", "websocket"],
      timeout: 20000,
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      randomizationFactor: 0.5,
      withCredentials: true,
      forceNew: true,
      auth: callback => callback({ token: getStoredToken() }),
      autoConnect: true
    });
    let wasConnected = false;
    let refreshed = false;
    let disposed = false;
    socket.on("connect", () => {
      refreshed = false;
      if (wasConnected) window.dispatchEvent(new Event("app:reconnected"));
      wasConnected = true;
    });
    socket.on("connect_error", async error => {
      if (disposed || refreshed || !getStoredToken() ||
          !/token/i.test(error.message)) return;
      refreshed = true;
      try {
        await refreshSession();
        if (!disposed) socket.connect();
      } catch (_error) { /* HTTP interceptor handles an expired session. */ }
    });
    const disconnect = socket.disconnect.bind(socket);
    socket.disconnect = () => { disposed = true; return disconnect(); };
    return socket;
}

export default connectToSocket;
